module.exports = __webpack_public_path__ + "static/media/Eclipse Timelapse estabilizado.dbb347b7.mp4";